// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigation":"StaticNavigation-c23f8569765b96bc","item":"StaticNavigation-ccf071fed249e891","link":"StaticNavigation-fe3842b983237a45"};